import React from 'react';

const LED = {
  deepRed: '#e91e3c',
  red: '#ef4444',
  blue: '#2563eb',
  royalBlue: '#7c3aed',
  uvA: '#9333ea',
};

export default function VerticalFarmTower() {
  const shelves = [
    { y: 40, led: LED.deepRed, nm: '660nm', plants: 'Tomatoes' },
    { y: 130, led: LED.blue, nm: '450nm', plants: 'Lettuce' },
    { y: 220, led: LED.uvA, nm: '380nm', plants: 'Basil' },
    { y: 310, led: LED.red, nm: '630nm', plants: 'Peppers' },
    { y: 400, led: LED.royalBlue, nm: '430nm', plants: 'Microgreens' },
  ];
  return (
    <svg viewBox="0 0 360 520" className="vf-tower" aria-hidden="true">
      <defs>
        <filter id="glow" x="-50%" y="-200%" width="200%" height="600%">
          <feGaussianBlur stdDeviation="10" result="b"/>
          <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <linearGradient id="frameGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(0,60,30,0.15)"/>
          <stop offset="100%" stopColor="rgba(0,60,30,0.05)"/>
        </linearGradient>
      </defs>

      <rect x="40" y="10" width="280" height="500" rx="12" fill="none" stroke="url(#frameGrad)" strokeWidth="1.5"/>
      <line x1="40" y1="10" x2="40" y2="510" stroke="rgba(0,60,30,0.1)" strokeWidth="1"/>
      <line x1="320" y1="10" x2="320" y2="510" stroke="rgba(0,60,30,0.1)" strokeWidth="1"/>
      <line x1="180" y1="10" x2="180" y2="510" stroke="rgba(0,60,30,0.06)" strokeWidth="0.5" strokeDasharray="4 8"/>

      {shelves.map((s, i) => (
        <g key={i}>
          <rect x="50" y={s.y + 68} width="260" height="3" rx="1.5" fill="rgba(0,60,30,0.12)"/>
          <rect x="60" y={s.y} width="240" height="4" rx="2" fill={s.led} opacity="0.9"
            className="vf-led-bar" style={{ animationDelay: `${i*0.4}s` }}/>
          <polygon points={`60,${s.y+4} 300,${s.y+4} 280,${s.y+68} 80,${s.y+68}`}
            fill={s.led} opacity="0.04"/>
          <rect x="60" y={s.y} width="240" height="4" rx="2" fill={s.led} opacity="0.5" filter="url(#glow)"
            className="vf-led-pulse" style={{ animationDelay: `${i*0.4}s` }}/>

          {Array.from({ length: 12 }).map((_, j) => (
            <circle key={j} cx={72 + j * 20} cy={s.y + 2} r="1.5" fill={s.led} opacity="0.8"
              className="led-dot-blink" style={{ animationDelay: `${i*0.3 + j*0.08}s` }}/>
          ))}

          {Array.from({ length: 8 }).map((_, j) => {
            const px = 80 + j * 28;
            const h = 18 + Math.random() * 20;
            const species = (i + j) % 4;
            return (
              <g key={j} className="vf-plant" style={{ animationDelay: `${i*0.3 + j*0.12}s` }}>
                <line x1={px} y1={s.y+66} x2={px} y2={s.y+66-h} stroke="#2e7d32" strokeWidth="1.2" opacity="0.8"/>
                {species === 0 && <>
                  <ellipse cx={px-5} cy={s.y+66-h+4} rx="7" ry="5" fill="#66bb6a" opacity="0.8"/>
                  <ellipse cx={px+5} cy={s.y+66-h+2} rx="7" ry="5" fill="#81c784" opacity="0.75"/>
                  <ellipse cx={px} cy={s.y+66-h-2} rx="6" ry="4.5" fill="#a5d6a7" opacity="0.7"/>
                </>}
                {species === 1 && <>
                  <ellipse cx={px-4} cy={s.y+66-h+3} rx="4.5" ry="6.5" fill="#43a047" opacity="0.8" transform={`rotate(-20 ${px-4} ${s.y+66-h+3})`}/>
                  <ellipse cx={px+4} cy={s.y+66-h+1} rx="4.5" ry="6.5" fill="#66bb6a" opacity="0.75" transform={`rotate(20 ${px+4} ${s.y+66-h+1})`}/>
                  <ellipse cx={px} cy={s.y+66-h-4} rx="3.5" ry="5.5" fill="#81c784" opacity="0.7"/>
                </>}
                {species === 2 && <>
                  {[-3,-1,1,3].map(k => (
                    <line key={k} x1={px+k} y1={s.y+66} x2={px+k*1.8} y2={s.y+66-h+2} stroke="#388e3c" strokeWidth="0.8" opacity="0.7"/>
                  ))}
                  {[-4,-1,2,5].map(k => (
                    <circle key={k} cx={px+k*1.8} cy={s.y+66-h+1} r="2.5" fill="#69f0ae" opacity="0.75"/>
                  ))}
                </>}
                {species === 3 && <>
                  <circle cx={px} cy={s.y+66-h-1} r="4" fill="#e53935" opacity="0.7"/>
                  <ellipse cx={px-4} cy={s.y+66-h+6} rx="5" ry="4" fill="#4caf50" opacity="0.7" transform={`rotate(-10 ${px-4} ${s.y+66-h+6})`}/>
                  <ellipse cx={px+4} cy={s.y+66-h+6} rx="5" ry="4" fill="#66bb6a" opacity="0.65" transform={`rotate(10 ${px+4} ${s.y+66-h+6})`}/>
                </>}
              </g>
            );
          })}

          <text x="328" y={s.y+20} fill="rgba(0,60,30,0.4)" fontSize="7.5" fontFamily="monospace">{s.nm}</text>
          <text x="328" y={s.y+32} fill="rgba(0,60,30,0.3)" fontSize="6.5" fontFamily="system-ui">{s.plants}</text>
        </g>
      ))}

      {[0,1,2,3].map(i => (
        <circle key={i} cx={100 + i * 60} cy="0" r="2" fill={LED.blue} opacity="0.5"
          className="vf-drip" style={{ animationDelay: `${i*0.9}s` }}/>
      ))}
    </svg>
  );
}
